import cn from 'classnames'
import React, { useContext } from 'react'
import { Image as DatoImage } from 'react-datocms'

import { SiteDataContext } from '../../components'
import ButtonNew from '../ButtonNew/ButtonNew'
import { FeatureCard } from '../FeatureCard'
import SectionHeader from '../SectionHeader'
import { withAnchor } from '../hooks'

const ThreeCardsWithImage = ({
  title,
  eyebrow = '',
  features = [],
  classes = '',
  theme = 'light',
  cardsContainerTheme = 'light',
  action = null,
  image
}) => {
  const { isTextRtl } = useContext(SiteDataContext)

  // Build section classes
  const sectionClasses = cn('l-section c-cards-with-image', classes, {
    'c-cards-with-image--rtl': isTextRtl,
    'l-section--black': theme === 'dark',
    'l-section--grey': theme === 'grey'
  })

  // Build body classes
  const bodyClasses = cn('c-cards-with-image__body', {
    'c-cards-with-image__body--withImage': !image
  })

  // Build cards container classes
  const cardsContainerClasses = cn('c-cards-with-image__cards-container', {
    [`c-cards-with-image__cards-container--${cardsContainerTheme}`]: cardsContainerTheme
  })

  // Render individual feature card
  const renderFeatureCard = (feature) => {
    const { id, action, title, description, bulletListColor } = feature

    const cardClasses = cn('c-cards-with-image__card', {
      [`c-cards-with-image__card--${cardsContainerTheme}`]: cardsContainerTheme
    })

    const cardContent = (
      <FeatureCard
        classes={cardClasses}
        description={description}
        title={title}
        bulletListColor={bulletListColor}
      >
        {action && (
          <ButtonNew icon="ti-arrow-right" variant="secondary" {...action} size="md">
            {action.text}
          </ButtonNew>
        )}
      </FeatureCard>
    )

    // Wrap with NavLink if action exists
    return action ? (
      <div
        key={`story-${id}`}
        onClick={() => (window.location.href = action.url)}
        style={{ cursor: 'pointer' }}
        role="link"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            window.location.href = action.url
          }
        }}
      >
        {cardContent}
      </div>
    ) : (
      <div key={`story-${id}`}>{cardContent}</div>
    )
  }

  return (
    <section className={sectionClasses}>
      <div className="l-container:12/12 l-container--default-spacing">
        {/* Header Section */}
        {title && (
          <div className="l-grid l-grid--align:middle c-cards-with-image__header">
            <div className="l-container:8/12 c-cards-with-image__header__title">
              <SectionHeader title={title} eyebrow={eyebrow} inverted={theme === 'dark'} />
            </div>
            <div>{action}</div>
          </div>
        )}

        {/* Body Section */}
        <div className={bodyClasses}>
          {/* Image Container */}
          {image && (
            <div className="c-cards-with-image__image-container">
              <DatoImage
                data={image.responsiveImage}
                className="c-cards-with-image__image"
                style={{
                  objectFit: 'contain',
                  height: '100%'
                }}
                imgStyle={{ objectFit: 'contain' }}
              />
            </div>
          )}

          {/* Cards Container */}
          <div className={cardsContainerClasses}>{features?.map(renderFeatureCard)}</div>
        </div>
      </div>
    </section>
  )
}

export default withAnchor(ThreeCardsWithImage)
